import React from 'react'
import MatrizItens from '../../../../components/performance/MatrizItens'

export default function MatrizPage() {
  return (
    
            <MatrizItens />
          
  )
}
